import { useEffect, useState } from "react";
import { api, fmt } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";
import { PageHeader, Card } from "@/components/ui-kit";
import { ResponsiveContainer, BarChart, Bar, XAxis, Tooltip } from "recharts";
import { InstallPrompt } from "@/components/InstallPrompt";
import { MyUpcomingShifts } from "@/components/Roster";

export default function Overview() {
  const { restaurant } = useAuth();
  const { t } = useT();
  const [s, setS] = useState(null);
  useEffect(() => { if (restaurant) api.get(`/restaurants/${restaurant.id}/stats`).then((r) => setS(r.data)); }, [restaurant]);
  if (!s) return null;
  const kpis = [
    ["revenue_today", fmt(s.revenue_today)], ["receipts_today", s.receipts_today], ["covers", s.covers_today], ["avg_ticket", fmt(s.avg_ticket)],
    ["open_orders", s.open_orders], ["occupied_tables", `${s.tables_occupied}/${s.tables_total}`], ["reservations_today", s.reservations_today],
  ];
  return (
    <div>
      <InstallPrompt />
      <PageHeader title={t("nav_overview")} />
      <MyUpcomingShifts />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {kpis.map(([k, v], i) => (
          <Card key={k} data-testid={`kpi-${k}`} className="rise" style={{ animationDelay: `${i * 60}ms` }}>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{t(k)}</p>
            <p className="mt-2 font-heading text-3xl font-extrabold text-slate-900">{v}</p>
          </Card>
        ))}
      </div>
      <div className="mt-6 grid gap-4 lg:grid-cols-3">
        <Card className="lg:col-span-2">
          <p className="mb-4 font-heading font-bold text-slate-900">{t("last_7")}</p>
          <div className="h-56">
            <ResponsiveContainer><BarChart data={s.week}><XAxis dataKey="date" tickFormatter={(d) => d.slice(5)} fontSize={12} /><Tooltip formatter={(v) => fmt(v)} /><Bar dataKey="total" fill="#5aa469" radius={[6, 6, 0, 0]} /></BarChart></ResponsiveContainer>
          </div>
        </Card>
        <Card>
          <p className="mb-4 font-heading font-bold text-slate-900">{t("top_items")}</p>
          {s.top_items.length === 0 && <p className="text-sm text-slate-500">—</p>}
          <ul className="space-y-3">{s.top_items.map((i) => <li key={i.name} className="flex justify-between text-sm"><span className="text-slate-700">{i.name}</span><span className="font-bold text-slate-900">×{i.qty}</span></li>)}</ul>
        </Card>
      </div>
    </div>
  );
}
